import FullInfoField from 'components/FullInfoField/FullInfoField';
import React, { useContext } from 'react';
import {
	DishFullInfoContext,
	IDishFullInfoContext,
} from '../../../../../../../../../dishFullInfoState/dishFullInfoContext';

const ArticleField: React.FC = () => {
	const { dishForFullInfo } = useContext<IDishFullInfoContext>(DishFullInfoContext);

	return <FullInfoField label="articleNumberLabel" value={dishForFullInfo?.articleNumber} />;
};

export default ArticleField;
